// extracted by mini-css-extract-plugin
module.exports = {"richtext_content":"Richtext_richtext_content__2Dx9C","body_container":"Richtext_body_container__dY3o4"};